import { render, staticRenderFns } from "./DocumentMenu.vue?vue&type=template&id=4d3cc847&scoped=true"
import script from "./DocumentMenu.vue?vue&type=script&lang=js"
export * from "./DocumentMenu.vue?vue&type=script&lang=js"
import style0 from "./DocumentMenu.vue?vue&type=style&index=0&id=4d3cc847&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3cc847",
  null
  
)

export default component.exports